import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import imgHANSAFLEX_Ireland_Xcode_Homepage from '../../assets/Home/HANSAFLEX_Ireland_Xcode_Homepage.webp';
import imgHANSAFLEX_Ireland_Hydraulicervicevan_Homepage from '../../assets/Home/HANSAFLEX_Ireland_Hydraulicervicevan_Homepage.webp';
import './FullPageCarousel.css'; // Import CSS file
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRegion } from '../../contexts/RegionContext';
import { homePageContent } from '../../data/regions/homePageContent';

function FullPageCarousel() {
  const { t } = useTranslation();
  const { currentRegion } = useRegion();

  // Get region-specific content
  const regionContent = homePageContent[currentRegion];

  const imageContainerStyle = {
    position: 'relative', // Make the container relative for absolute positioning of overlay
    maxHeight: '100%', // Set max height to auto
    maxWidth: '100%', // Set max width to auto
    overflow: 'hidden', // Hide overflow to crop image
    margin: '0 auto', // Center the container horizontally
    width: '100vw', // Set width to fill the viewport width
    display: 'flex', // Set display to flex
    justifyContent: 'center', // Center content horizontally
    alignItems: 'center' // Center content vertically
  };

  const imageStyle = {
    width: '100%', // Set width to fill container
    height: 'auto', // Maintain aspect ratio
    objectFit: 'cover' // Crop the image to cover the entire container
  };

  const titleStyle = {
    marginBottom: '50px',
  };

  const descriptionStyle = {
    marginBottom: '30px', // Set bottom margin for description
    marginLeft: '20%', // Set left margin for description
    marginRight: '20%' // Set right margin for description
  };

  const buttonStyle = {
    backgroundColor: 'rgb(212,51,75)', // Button background color
    color: 'white', // Button text color
    padding: '10px 20px', // Button padding
    borderRadius: '5px', // Button border radius
    border: 'none', // Remove button border
    cursor: 'pointer', // Add cursor pointer on hover
    textDecoration: 'none', // Remove underline from button text
    width: '200px', // Adjust button width to fit content
    display: 'inline-block',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '500'
  };

  const buttonWrapperStyle = {
    textAlign: 'center', // Center content horizontally within the wrapper
    marginBottom: '60px', // Set bottom margin for button wrapper
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };

  // Render button based on whether it's an external link or internal route
  const renderButton = (buttonText, buttonLink) => {
    if (buttonLink.startsWith('http')) {
      return (
        <a href={buttonLink} target="_blank" rel="noopener noreferrer" style={buttonStyle}>
          {t(buttonText)}
        </a>
      );
    } else {
      return (
        <Link to={buttonLink} style={buttonStyle}>
          {t(buttonText)}
        </Link>
      );
    }
  };

  return (
    <Carousel>
      <Carousel.Item interval={2500} className='main-carousel-item'>
        <div style={imageContainerStyle} >
          <img className='main-carousel-image'
            src={imgHANSAFLEX_Ireland_Hydraulicervicevan_Homepage}
            alt="title"
            style={imageStyle}
          />
          <div className="image-overlay"> {/* Add the overlay */}
            <h3 className='c-slide-title' style={titleStyle}>{t(regionContent.carousel.slide1.title)}</h3>
            <p className='c-slide-desc' style={descriptionStyle}>{t(regionContent.carousel.slide1.description)}</p>
            <div style={buttonWrapperStyle}> {/* Button wrapper */}
              {renderButton(regionContent.carousel.slide1.buttonText, regionContent.carousel.slide1.buttonLink)}
            </div>
          </div>
        </div>
      </Carousel.Item>
      <Carousel.Item interval={2500} className='main-carousel-item'>
        <div style={imageContainerStyle} >
          <img className='main-carousel-image'
            src={imgHANSAFLEX_Ireland_Xcode_Homepage}
            alt="title"
            style={imageStyle}
          />
          <div className="image-overlay"> {/* Add the overlay */}
            <h3 className='c-slide-title' style={titleStyle}>{t(regionContent.carousel.slide2.title)}</h3>
            <p className='c-slide-desc' style={descriptionStyle}>{t(regionContent.carousel.slide2.description)}</p>
            <div style={buttonWrapperStyle}> {/* Button wrapper */}
              {renderButton(regionContent.carousel.slide2.buttonText, regionContent.carousel.slide2.buttonLink)}
            </div>
          </div>
        </div>
      </Carousel.Item>
      {/*add more carousel items here*/}
    </Carousel>
  );
}

export default FullPageCarousel;
